module.exports = __webpack_public_path__ + "img/02.d8356f03.png";